import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { apiService } from "../../services/apiService";
import { API_ENDPOINTS } from "../../services/apiEndpoints";
import Pagination from "../../components/Pagination";

const SanitarywareInquiryClickList = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    total_pages: 1,
    total_count: 0,
    has_next: false,
    has_previous: false,
  });

  const fetchInquiryClicks = async () => {
    setLoading(true);
    try {
      const response = await apiService.get(
        API_ENDPOINTS.BUYERS.SANITARYWARE_INQUIRY_CLICK_LIST
      );
      if (response.inquiry_clicks) {
        setInquiries(response.inquiry_clicks || []);
        if (response.pagination) {
          setPagination(response.pagination);
        }
      } else {
        toast.error(response.message || "Failed to fetch inquiry clicks");
      }
    } catch (error) {
      console.error("Error fetching inquiry clicks:", error);
      toast.error("Failed to fetch inquiry clicks");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    fetchInquiryClicks();
  };

  const handleViewDetails = (inquiry) => {
    setSelectedInquiry(inquiry);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedInquiry(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  useEffect(() => {
    fetchInquiryClicks();
  }, []);

  return (
    <>
      <div className="page-header mb-3">
        <div className="row align-items-center">
          <div className="col">
            <h3 className="page-title">Sanitaryware Inquiry Click List</h3>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Inquiry Clicks</h5>
              <div className="card-tools">
                <span className="badge bg-primary">
                  Total: {pagination.total_count || inquiries.length}
                </span>
              </div>
            </div>
            <div className="card-body">
              {loading ? (
                <div className="text-center py-4">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-striped table-hover">
                      <thead>
                        <tr>
                          <th>Sr.No</th>
                          <th>Buyer</th>
                          <th>GST</th>
                          <th>Product</th>
                          <th>Grade</th>
                          <th>Seller Place</th>
                          <th>Click Count</th>
                          <th>Last Click Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {inquiries.length === 0 ? (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No inquiry clicks found
                            </td>
                          </tr>
                        ) : (
                          inquiries.map((inquiry, index) => (
                            <tr key={index}>
                               <td>{index + 1 + (pagination.current_page - 1) * 10}</td>
                              <td>{inquiry.buyer?.firm_name || "N/A"}</td>
                              <td>{inquiry.buyer?.gst_number || "N/A"}</td>
                              <td>{inquiry.product?.name || "N/A"}</td>
                              <td>{inquiry.product?.grade || "N/A"}</td>
                              <td>{inquiry.product?.seller_place || "N/A"}</td>
                              <td>{inquiry.click_count || 0}</td>
                              <td>{formatDate(inquiry.last_clicked_at)}</td>
                              <td>
                                <div className="actions">
                                  <button
                                    className="btn btn-sm btn-outline-primary me-2"
                                    title="View Details"
                                    onClick={() => handleViewDetails(inquiry)}
                                  >
                                    <i className="fe fe-eye"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    currentPage={pagination.current_page}
                    totalPages={pagination.total_pages}
                    onPageChange={handlePageChange}
                    loading={loading}
                    showPageInfo={true}
                    className="mt-3"
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {showModal && selectedInquiry && (
        <>
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Inquiry Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <h6
                    className="text-primary fw-bold mb-3"
                    style={{ color: "#2e1065" }}
                  >
                    Buyer Info
                  </h6>
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Firm Name</th>
                        <td>{selectedInquiry.buyer?.firm_name || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Owner Name</th>
                        <td>{selectedInquiry.buyer?.owner_name || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>GST Number</th>
                        <td>{selectedInquiry.buyer?.gst_number || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Mobile</th>
                        <td>{selectedInquiry.buyer?.office_mobile || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Address</th>
                        <td>
                          {selectedInquiry.buyer?.address?.address_line}<br />
                          {selectedInquiry.buyer?.address?.road}<br />
                          {selectedInquiry.buyer?.address?.city}<br />
                          {selectedInquiry.buyer?.address?.district}<br />
                          {selectedInquiry.buyer?.address?.state} -{" "}
                          {selectedInquiry.buyer?.address?.pin_code}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h6
                    className="text-primary fw-bold mb-3 mt-4"
                    style={{ color: "#2e1065" }}
                  >
                    Product Info
                  </h6>
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Name</th>
                        <td>{selectedInquiry.product?.name || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Description</th>
                        <td>{selectedInquiry.product?.description || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Color</th>
                        <td>{selectedInquiry.product?.color || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Grade</th>
                        <td>{selectedInquiry.product?.grade || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Glaze</th>
                        <td>{selectedInquiry.product?.glaze || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Seller Place</th>
                        <td>
                          {selectedInquiry.product?.seller_place || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Quantity Range</th>
                        <td>
                          {selectedInquiry.product?.quantity_range || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Packing</th>
                        <td>{selectedInquiry.product?.packing || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Logo</th>
                        <td>{selectedInquiry.product?.logo || "N/A"}</td>
                      </tr>
                    </tbody>
                  </table>
                  <h6
                    className="text-primary fw-bold mb-3 mt-4"
                    style={{ color: "#2e1065" }}
                  >
                    Seller Info
                  </h6>
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Firm Name</th>
                        <td>{selectedInquiry.seller?.firm_name || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Owner Name</th>
                        <td>{selectedInquiry.seller?.owner_name || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>GST Number</th>
                        <td>{selectedInquiry.seller?.gst_number || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Mobile Number</th>
                        <td>{selectedInquiry.seller?.mobile_number || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Office Mobile</th>
                        <td>{selectedInquiry.seller?.office_mobile || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Seller Type</th>
                        <td>{selectedInquiry.seller?.seller_type || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Seller Place</th>
                        <td>{selectedInquiry.seller?.seller_place || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Average Rating</th>
                        <td>{selectedInquiry.seller?.average_rating || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Follower Count</th>
                        <td>{selectedInquiry.seller?.follower_count || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Post Counts</th>
                        <td>{selectedInquiry.seller?.post_counts || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Is Verified</th>
                        <td>
                          
                            {selectedInquiry.seller?.is_verified ? 'Yes' : 'No'}
                         
                        </td>
                      </tr>
                      <tr>
                        <th>Subscription Status</th>
                        <td>
                        
                            {selectedInquiry.seller?.subscription_status ? 'Active' : 'Inactive'}
                          
                        </td>
                      </tr>
                      <tr>
                        <th>Categories</th>
                        <td>
                          {selectedInquiry.seller?.categories?.map(category => category.name).join(', ') || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Address</th>
                        <td>
                          {selectedInquiry.seller?.address?.address_line}<br />
                          {selectedInquiry.seller?.address?.road}<br />
                          {selectedInquiry.seller?.address?.city}<br />
                          {selectedInquiry.seller?.address?.district_name_display}<br />
                          {selectedInquiry.seller?.address?.state_name_display} -{" "}
                          {selectedInquiry.seller?.address?.pin_code}
                        </td>
                      </tr>
                      <tr>
                        <th>Summary</th>
                        <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                          {selectedInquiry.seller?.summary || "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
};

export default SanitarywareInquiryClickList;
